import { useSearchParams } from "react-router-dom";

const useDoctorsSearch = (): {
  search: string;
  filter: string;
  isPremium: boolean;
  page: number;
  onSearchChange(search: string): void;
  onFilterChange(filter: string): void;
  onPremiumChange(premium: boolean): void;
  onPageChange(page: number): void;
  onReset(): void;
} => {
  const [params, setParams] = useSearchParams();

  const {
    search = "",
    filter = "",
    premium = "false",
    page = "1",
  } = Object.fromEntries(params.entries());

  const current = {
    ...(search && { search }),
    ...(filter && { filter }),
    ...(premium && { premium }),
  };

  const onSearchChange = (search: string) => {
    setParams({ ...current, search }, { replace: true });
  };

  const onFilterChange = (filter: string) => {
    setParams({ ...current, filter: filter }, { replace: true });
  };

  const onPremiumChange = (premium: boolean) => {
    setParams({ ...current, premium: String(premium) }, { replace: true });
  };

  const onPageChange = (page: number) => {
    setParams({ ...current, page: String(page) }, { replace: true });
  };

  const onReset = () => {
    setParams({}, { replace: true });
  };

  return {
    search,
    filter,
    isPremium: JSON.parse(premium),
    page: JSON.parse(page),
    onSearchChange,
    onFilterChange,
    onPremiumChange,
    onPageChange,
    onReset,
  };
};

export { useDoctorsSearch };
